import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule, XsI18nPipe } from '@nx-fe/pipes';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { TicketCreateComponent } from './components/ticket-create/ticket-create.component';
import { TicketCreateDialogComponent } from './components/ticket-create/ticket-create-dialog/ticket-create-dialog.component';
import { TicketCreationComponent } from './components/ticket-create/ticket-create/ticket-creation.component';
import { SharedComponentsModule } from 'app/shared/shared-components.module';
import { MatOptionModule } from '@angular/material/core';
import { SelectModule } from '@soti/select';
import { SotiPopup } from '@soti/popup';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [TicketCreateComponent, TicketCreateDialogComponent, TicketCreationComponent],
  exports: [TicketCreateComponent, TicketCreateDialogComponent, TicketCreationComponent],
  imports: [
    CommonModule,
    SharedComponentsModule,
    MatDialogModule,
    MatSelectModule,
    SelectModule,
    MatOptionModule,
    FormsModule,
    MatTooltipModule,
    PipesModule,
  ],
  providers: [XsI18nPipe],
})
export class TicketCreationModule {}
